export default __webpack_public_path__ + "static/upiautopay-67e2937f41e5d0aca81576430716430c.webp";